export const PHENOPHASES_MODULE_NAME = "phenophases";
